import axiosInstance from "../axiosInterceptor";

export async function emailRegister(body) {
  try {
    const response = await axiosInstance.post(`student/emailRegister`, body);
    const data = response?.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
}
